<div class="search-form">
    <mat-form-field appearance="outline">
      <mat-label>Date From/Until</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="From" [(ngModel)]="dateFrom">
          <input matEndDate placeholder="Until" [(ngModel)]="dateUntil">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <mat-form-field appearance="outline" >
      <mat-label>Age Groups *</mat-label>
        <input matInput placeholder="Age Groups" [(ngModel)]="ageGroups">
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="search()" class="report-btn"> <mat-icon>search</mat-icon> </button>
    <small class="memo">*To define age groups, use comma separated values (eg 0,20,40 for 0-19, 20-39, 40-..)</small>
</div>

<mat-tab-group *ngIf="memberStats" >
  <mat-tab label="Members By Country" *ngIf="memberStats && memberStats.memberCountries && memberStats.memberCountries.length">
    <table mat-table [dataSource]="dataSourceCountry" class="mat-elevation-z8" *ngIf="dataSourceCountry">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Country  </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.description}} </td>
        <td mat-footer-cell *matFooterCellDef> Total </td>
      </ng-container>
      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.qty}} </td>
        <td mat-footer-cell *matFooterCellDef class="qty-row">  {{memberStats.memberCountries[0].total}} </td>
      </ng-container>
      <ng-container matColumnDef="pct">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.pct}}% </td>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsPct"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsPct;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumnsPct" class="total-row"></tr>
  </table>
  </mat-tab>
  <mat-tab label="Members by Marketing Channel" *ngIf="memberStats && memberStats.memberMarketingChannels && memberStats.memberMarketingChannels.length">
    <table mat-table [dataSource]="dataSourceMChannel" class="mat-elevation-z8"  *ngIf="dataSourceMChannel">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Marketing Channel </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.description}} </td>
        <td mat-footer-cell *matFooterCellDef> Total </td>
      </ng-container>
      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.qty}} </td>
        <td mat-footer-cell *matFooterCellDef class="qty-row">  {{memberStats.memberMarketingChannels[0].total}} </td>
      </ng-container>
      <ng-container matColumnDef="pct">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.pct}}%</td>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsPct"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsPct;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumnsPct" class="total-row"></tr>
    </table>
  </mat-tab>
  <mat-tab label="Members By Age" *ngIf="memberStats && memberStats.memberAgeGroups && memberStats.memberAgeGroups.length">
    <table mat-table [dataSource]="dataSourceAge" class="mat-elevation-z8"  *ngIf="dataSourceAge">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Age Group </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.description}} </td>
        <td mat-footer-cell *matFooterCellDef> Total </td>
      </ng-container>
      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.qty}} </td>
        <td mat-footer-cell *matFooterCellDef class="qty-row">  {{memberStats.memberAgeGroups[0].total}} </td>
      </ng-container>
      <ng-container matColumnDef="pct">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.pct}}%</td>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsPct"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsPct;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumnsPct" class="total-row"></tr>
    </table>
  </mat-tab>
  <mat-tab label="Services">
    <h2 class="service-header">Services</h2>
    <table mat-table [dataSource]="dataSourceProduct" class="mat-elevation-z8"  *ngIf="dataSourceProduct">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Service </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.description}} </td>
        <td mat-footer-cell *matFooterCellDef> Total </td>
      </ng-container>
      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Qty </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.qty}} </td>
        <td mat-footer-cell *matFooterCellDef  class="qty-row"> {{memberProductsQtyTotal}}  </td>
      </ng-container>
      <ng-container matColumnDef="startingPrice">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;">Starting Price</th>
        <td mat-cell *matCellDef="let element" > {{element.startingPrice}} </td>
        <td mat-footer-cell *matFooterCellDef  class="qty-row">  {{memberProductsStartingPriceTotal}} </td>
      </ng-container>
      <ng-container matColumnDef="finalPrice">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;">Final Price</th>
        <td mat-cell *matCellDef="let element" > {{element.finalPrice}}</td>
        <td mat-footer-cell *matFooterCellDef class="last-total-col">  {{memberProductsFinalPriceTotal}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsProduct"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsProduct;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumnsProduct"  class="total-row"></tr>
    </table>
    <h2 class="service-header">Payments</h2>
    <table mat-table [dataSource]="dataSourcePaymentMethod" class="mat-elevation-z8"  *ngIf="dataSourcePaymentMethod">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Payment Method </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.description}} </td>
        <td mat-footer-cell *matFooterCellDef> Total </td>
      </ng-container>
      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Qty </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.qty}} </td>
        <td mat-footer-cell *matFooterCellDef  class="qty-row"> {{memberPaymentMethodsQtyTotal}}   </td>
      </ng-container>
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;">Amount</th>
        <td mat-cell *matCellDef="let element" > {{element.amount}} </td>
        <td mat-footer-cell *matFooterCellDef  class="last-total-col">  {{memberPaymentMethodsTotal}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsPaymentMethod"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsPaymentMethod;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumnsPaymentMethod"  class="total-row"></tr>
    </table>
  </mat-tab>
</mat-tab-group>
